import React from 'react';
import { useAuth } from 'services/auth-service';
import AccountSaveMode from 'components/structure/Account/AccountSaveMode';
import AccountViewMode from 'components/structure/Account/AccountViewMode';

export default function AccountDashboard() {
  const {
    state: { user }
  } = useAuth();

  return user.role === 'SUPER' ? <AccountSaveMode /> : <AccountViewMode />;
}
